export default "__VITE_ASSET__fqmguo2C__"